import {getAgeFromIdCardFilter, getSexFromIdCardFilter} from "./filters";
import {systemService} from "./service/system";

export const getRandomIdCard = () => {
  const area = ['120101', '110101', '130102', '370829', '140105'];
  const y = ['1960', '1970', '1980', '1990', '2000'];
  const m = ['08', '09', '10', '11', '12'];
  const d = ['01', '02', '03', '05', '28'];
  const random = ['061', '072', '083', '094', '105'];
  const q = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const last = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
  const r = () => {
    return Math.floor(Math.random() * area.length)
  };
  let str = '', total = 0;
  str += area[r()] + y[r()] + m[r()] + d[r()] + random[r()];
  for (let i = 0; i < str.length; i++) {
    total += str[i] * q[i];
  }
  str += last[total % 11];
  return str;
};

export const getRandomName = () => {
  const x = '赵钱孙李周吴郑王冯陈褚卫蒋沈韩杨';
  const q = ['尚志', '学森', '行者', '云龙', '杰伦', '客群', '少秋', '国威', '小刚', '意涵', '时健', '斯理', '梦洁', '梦辰', '东君', '钰莹'];
  const r = () => {
    return Math.floor(Math.random() * x.length)
  };
  return x[r()] + q[r()];
};

export const getRandomMobile = () => {
  const r = (n) => {
    return Math.floor(Math.random() * n);
  };
  const x = ['134', '158', '189'];
  const q = '0123456789';
  return x[r(3)] + ('1'.repeat(8).split('').map(() => q[r(10)]).join(''));
};

export const getRandomNum = (max) => {
  return Math.floor(Math.random() * max);
};

export const getRandomStr = (length) => {
  const q = '0123456789';
  return '1'.repeat(length).split('').map(() => q[getRandomNum(q.length)]).join('');
};

export const getRandomHisPatInfo = async () => {
  const idcard = getRandomIdCard();
  const code = idcard.substr(0, 6);
  return {
    age: getAgeFromIdCardFilter(idcard, ''),
    sex: getSexFromIdCardFilter(idcard),
    consulterName: getRandomName(),
    consulterIdcard: idcard,
    consulterMobile: getRandomMobile(),
    consulterJob: '教师',
    consulterInhosno: getRandomStr(8),
    consulterAddress: await systemService.areaGet(code),
    maritalStatus: getRandomNum(4) + '',
    consulterAreaCode: code,
    otherContactWay: getRandomStr(9) + '@qq.com',
    docTelphone: getRandomMobile()
  }
};
